import { Routes } from '@angular/router';
import { SubscribersComponent } from './subscribers/subscribers.component';

export const SubscribersRoutingModule: Routes = [
	{ path: 'subscribers', component: SubscribersComponent },
];
